/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminSeedTeamMember } from './AdminSeedTeamMember';
import {
    AdminSeedTeamMemberFromJSON,
    AdminSeedTeamMemberFromJSONTyped,
    AdminSeedTeamMemberToJSON,
    AdminSeedTeamMemberToJSONTyped,
} from './AdminSeedTeamMember';

/**
 * 
 * @export
 * @interface AdminSeedTeamBody
 */
export interface AdminSeedTeamBody {
    /**
     * Team name
     * @type {string}
     * @memberof AdminSeedTeamBody
     */
    name: string;
    /**
     * Team members (can be external players without DevourPlay accounts)
     * @type {Array<AdminSeedTeamMember>}
     * @memberof AdminSeedTeamBody
     */
    members: Array<AdminSeedTeamMember>;
    /**
     * Optional seed position
     * @type {number}
     * @memberof AdminSeedTeamBody
     */
    seed?: number;
}

/**
 * Check if a given object implements the AdminSeedTeamBody interface.
 */
export function instanceOfAdminSeedTeamBody(value: object): value is AdminSeedTeamBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function AdminSeedTeamBodyFromJSON(json: any): AdminSeedTeamBody {
    return AdminSeedTeamBodyFromJSONTyped(json, false);
}

export function AdminSeedTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSeedTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'members': ((json['members'] as Array<any>).map(AdminSeedTeamMemberFromJSON)),
        'seed': json['seed'] == null ? undefined : json['seed'],
    };
}

export function AdminSeedTeamBodyToJSON(json: any): AdminSeedTeamBody {
    return AdminSeedTeamBodyToJSONTyped(json, false);
}

export function AdminSeedTeamBodyToJSONTyped(value?: AdminSeedTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'members': ((value['members'] as Array<any>).map(AdminSeedTeamMemberToJSON)),
        'seed': value['seed'],
    };
}

